<div class="template1">
    <ul class="list-unstyled list-inline  d-none d-md-block" tabindex="-1" role="list"
        *ngIf="!countryListHidden && countryLangSettings">
        <!-- <li role="listitem" class="dropdown rel-pos pad-l-0" (click)="showPopup(true)" (click)="showPopup(false)" dropdown [autoClose]="false" [(isOpen)]="isCountryPopupOpen"> -->
        <li autofocus role="listitem" class="dropdown rel-pos pad-l-0" id="countryLanguageSelection" tabindex="0"
            attr.aria-label="{{'header.Click to change Region and Language' |translate|translateKey}}"
            (click)="showSplashScreen()" (keyup.enter)="showSplashScreen()">
            <div id="chooseCountry" role="button" aria-label="select country" class="" dropdownToggle tabindex="-1">
                <input type="hidden" class="btn-select-input" id="" name="" value="" />
                <div class="btn-select-value sel-country  d-md-inline-block pointer" tabindex="-1">
                    <span class="flag-icon  flag-icon-{{selectedCountry?.isocodeTwo|lowercase}}"></span>
                    <span
                        class="header-country d-none pl-2 d-md-inline">{{selectedCountry?.displayText|| selectedCountry?.name}}</span>
                    <span class="header-country pl-2">{{selectedLanguageName|slice:0:3}} </span>
                    <span class="fa fa-chevron-down"></span>
                </div>
            </div>
        </li>
    </ul>
    <div appClickOutside (clickOutside)="outsideClickCloseSplashScreen($event)" #countrySplash
        class="country-language h-100 row" *ngIf="canShowSplashScreen" [style.padding-bottom.px]="getSplashTopMargin()"
        [style.margin-top.px]="getSplashTopMargin()" (keyup.esc)=" onEscape()">
        <div tabindex="0" class="container-fluid m-0 scroll-y" class="" slimScroll [autoFocus]="true" width="100%"
            size="8px" height="inherit" alwaysVisible="true" wheelStep="20">
            <div class="row justify-content-center align-items-center mt-2 country__header country-logo-container">
                <div class="text-center">
                    <div class="d-none py-2" *ngIf="!(countryLangSettings && marginFlag)">
                        <img src="https://seeklogo.com/images/F/forever-living-logo-D0AC984DBD-seeklogo.com.png" />
                    </div>
                    <h1 class="welcome-text" *ngIf="!(countryLangSettings && marginFlag)">
                        {{'countrySplash.welcome'|translate|translateKey }}</h1>
                    <div class="welcome-slogan text-uppercase">
                        {{'countrySplash.select'|translate|translateKey}}
                        {{'countrySplash.Region and Language'|translate|translateKey }}
                    </div>
                    <div *ngIf="userInfo && isDistributor" class="wholesale-qualified">
                        {{'countrySplash.Not finding the country in which you want to purchase?'|translate|translateKey}}
                        <a class="link--light" href="javascript:void(0);"
                            (click)="instantAuthorizationNavigation()">{{'countrySplash.Click here'|translate|translateKey}}</a>
                    </div>
                </div>
            </div>
            <div class="mx-2 mx-md-5">
                <div class="mx-auto d-none d-md-flex regions-block">
                <!-- <div class="mx-3 mx-md-auto d-md-flex regions-block"> -->
                    <ul class="row list-unstyled hidden-xs j-language-tabset tab-highlight d-none d-md-block"
                        role="tablist">
                        <li tabindex="0"
                            attr.aria-label="{{'countrySplash.click to select' |translate|translateKey }} {{portal.regionName}} {{'countrySplash.region' |translate|translateKey }}"
                            id="lang-list-tab1" (keyup.enter)="onRegionChange(portal.regionId,i)"
                            (click)="onRegionChange(portal.regionId,i)" (mouseover)="setIndex(i,true)"
                            (mouseleave)="setIndex(-1,false)"
                            *ngFor="let portal of portalCountries | orderBy : 'regionName'; let i = index;"
                            aria-selected="false" role="tab" aria-controls="lang-tab1"
                            [ngClass]="(portal && browserRegion )&&  (portal.regionId === browserRegion.regionId) ?'col text-left cursor-pointer background-white':'col text-left cursor-pointer '">
                            <div class="region-title">
                                <span class="region-title__text">{{portal.regionName}}</span>
                            </div>
                        </li>
                    </ul>
                    <div class="col-md p-4">
                        <div class="d-none mx-auto d-sm-block regions-img-block" *ngIf="browserRegion && browserRegion.regionId && portalCountriesForUser">
                    <!-- <div class="col-md p-2 p-sm-4">
                        <div class="mx-auto d-block regions-img-block" *ngIf="browserRegion && browserRegion.regionId && portalCountriesForUser"> -->
                            <app-reigon-selection [regionId]="browserRegion.regionId" [regionUrl]="portalImageUrl" [portalCountries]= "portalCountries" (regionIdChange)="onRegionChange($event)"></app-reigon-selection>
                        </div>
                    </div>
                </div>
                <div class="countries-block mx-auto font-weight-bold">
                    <div class="col-12 d-md-none">
                        <select role="listbox" id="regionlist" name="regionName" class="form-control"
                            [ngModel]="browserRegion" (ngModelChange)="onRegionSelect($event)">
                            <option role="option" [ngValue]="region"
                                *ngFor="let region of portalCountries | orderBy : 'regionName';let i = index"
                                [selected]="region.regionName === browserRegion?.regionName">{{region.regionName}}
                            </option>
                        </select>
                    </div>
                    <div class="text-center px-3 px-md-0 px-xl-3 mt-2 countries-list"
                        [class.full-visible]="(browserRegion)"
                        [@slideInOut]="(countrySplash.offsetWidth < 768 && browserRegion)?'in':'out'">
                        <div class="pb-3 mb-3 language--border">
                            <!--Map in Mobile View -->
                            <img class="d-md-none language-tabset-img p-3" [src]="portalImageUrl"
                                [alt]="browserRegion?.regionName">
                            <!-- Country selection List -->
                            <ul class="ul-language-list list-unstyled row" [style.height.px]="elementHeight">
                                <!-- col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3  -->
                                <!-- <li id="{{'country'+i}}" class="language-list"
                                *ngFor="let country of countries|orderBy:'name';let i=index;">
                                <a tabindex="0" id="{{'countrylnk'+i}}"
                                    attr.aria-label="{{'countrySplash.Click to select Language for' |translate|translateKey }} {{country.name}}"
                                    (keyup.enter)="onCountryChange(country,i,$event);" target="_self"
                                    class="a-languagelist mx-2 mx-md-0"
                                    (click)="onCountryChange(country,i,$event);"> -->
                                <li id="{{'country'+i}}" class="language-list"  *ngFor="let country of countries|orderBy:'displayText';let i=index;">
                                    <a tabindex="0" attr.aria-label="{{'countrySplash.Click to select Language for' |translate|translateKey }} {{country.name}}" (keyup.enter)="onCountryChange(country,i,$event);" target="_self" class="a-languagelist mx-2 mx-md-0" (click)="onCountryChange(country,i,$event);">
                                        <div class="country-white">
                                            <span
                                                class="pl-2 country-text">{{country.displayText || country.name}}</span>
                                            <span class="fa a-countrytext float-right"
                                                [ngClass]="selectedIndexCountry===i?'fa-angle-up':'fa-angle-down'"></span>
                                        </div>
                                    </a>
                                    <!-- language Selection List -->
                                    <ul class="ul-language-list list-unstyled p-0 line-height-1 language-dropmenu"
                                        [class.hasContent]="(store.languages&&store.languages.length>0) ||(countryLanguages&&countryLanguages.length>0)"
                                        *ngIf="(selectedIndexCountry===i)">
                                        <!-- [class.yellow-bg]="(selectedCountry && selectedCountry.countryId === country.countryId) && (selectedLanguageName === language.languageName)" -->
                                        <li class="localization" tabindex="-1"
                                            attr.aria-label="{{'countrySplash.select Language as' |translate|translateKey }} {{language.displayText}}"
                                            (keyup.enter)="setCountryLangInfo(language,$event)"
                                            *ngFor="let language of countryLanguages|orderBy:'languageName';let langIndex=index;"
                                            (click)="setCountryLangInfo(language,$event)">
                                            <a tabindex="0" id="{{'languageLnk'+langIndex}}">
                                                <div class="a-languagelist line-height-2">
                                                    <div class="autoship">
                                                        <div class="">
                                                            <span class="check-lbl">
                                                                <!-- label-text -->
                                                                <span *ngIf="language"
                                                                    class="">{{language.displayText}}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>